const { chunk, pickBy, get, omit, pick, isEmpty } = require('lodash');
const { addDays, } = require('date-fns');
const moji = require('moji');

const { prefectures, boxSizes, deliveryTimes, } = require('../config');
const { idWithTenant } = require('../util');

const { entries } = Object;
const allowedFileExtensions = ['pdf'];
const validateFile = file => file != null && (allowedFileExtensions.includes(file.name.split('.').pop()));
const statuses = {
  initial: { label: '確認中', color: '', },
  waitingToReceive: { label: '入荷待ち', color: 'warning', },
  waitingToCombine: { label: '加工待ち', color: '', },
  processing: { label: '加工作業中', color: 'secondary', },
  combined: { label: '加工済み', color: 'success', },
};

// NOTE: 旧データ（combinedProductId/combinedQuantityの単一）と新データ（combinedItemsの配列）の両方に対応
const getCombinedItems = (combiningRequest = {}) => {
  const { combinedItems, combinedProductId, combinedQuantity, } = combiningRequest;
  if(!isEmpty(combinedItems)) return combinedItems;
  if(combinedProductId != null) return [{ productId: combinedProductId, quantity: combinedQuantity, }];
  return [];
};

const fields = ({ products } = {}) => {
  return {};
};

const combinedItemFields = ({ items = [], products = [], } = {}) => {
  return {
    productId: {
      label: '完成商品',
      type: 'select',
      options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
      validations: {
        required: _ => !isEmpty(_),
        unique: v => items.filter(_ => _.productId === v).length < 2,
      },
      hint: '商品ID、SKU、ASINで検索できます',
    },
    quantity: {
      label: '完成数量',
      type: 'integer',
      validations: {
        greaterThan0: _ => _ > 0,
      },
    },
  };
};

const adminFields = ({ values, type, } = {}) => {
  return {
    status: {
      label: 'ステータス',
      type: 'select',
      options: entries(statuses).map(([k, _]) => ({ label: _.label, value: k })),
      validations: {
        required: _ => !isEmpty(_),
      },
      initialValue: 'initial',
    },
  };
};

module.exports = {
  itemFields: ({ items = [], products = [], } = {}) => {
    return {
      productId: {
        label: '商品',
        type: 'select',
        options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
        validations: {
          required: _ => !isEmpty(_),
          unique: v => items.filter(_ => _.productId === v).length < 2,
        },
        hint: '商品ID、SKU、ASINで検索できます',
      },
      quantity: {
        label: '数量',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
      },
    };
  },
  fields,
  combinedItemFields,
  getCombinedItems,
  adminFields,
  statuses,
};
